<script lang="ts">
	import { onMount } from 'svelte';
	import '../app.css';

	import { themeStore } from '$lib/stores/theme.svelte';
	import { initGA } from '$lib/analytics';
	import type { LayoutData } from './$types';

	let { data, children } = $props<{ data: LayoutData; children: any }>();

	onMount(() => {
		themeStore.initialize();
		initGA();
	});
</script>

<svelte:head>
	<link rel="icon" href="/favicon.png" />
	<title>Buk Atlas | Company Wiki</title>
	<meta name="description" content="buk atlas" />
</svelte:head>

{@render children()}
